import React from "react";
import styles from "./monster-card.module.css";
import { LOCALES, SAVIOR_ATTRIBUTE, SAVIOR_CLASS } from "../../constants";
import { getUIText } from "../../translation";

export default function MonsterCard({ lang, monster }) {
    const eng = monster.attr.replace("NUAT_", "").toLowerCase();

    return (
        <div className={`${styles["card"]} ${monster.isBoss ? styles["boss"] : ""}`}>
            {monster.isBoss && <span className={styles["boss-badge"]}>{getUIText(lang, "monster.card.boss")}</span>}
            <div className={`${styles["portrait"]} ${styles[eng]}`}>
                <img src={`${process.env.PUBLIC_URL}/images/icon/portrait/monster/${monster.img}`} alt={monster.name} />
                <div className={styles["class-overlay"]}>
                    <img src={`${process.env.PUBLIC_URL}/images/icon/portrait/${SAVIOR_ATTRIBUTE[monster.attr][LOCALES.KO]}.webp`} />
                    <img src={`${process.env.PUBLIC_URL}/images/icon/portrait/${SAVIOR_CLASS[monster.class][LOCALES.KO]}.webp`} />
                </div>
            </div>
            <div className={styles["name"]}>{monster.name}</div>
        </div>
    );
}
